import templateUrl from './lucky_six.html';

angular.module('terminalApp.nabLuckySixUi').directive('luckySixResults', function () {
  return {
    restrict: 'E',
    templateUrl: templateUrl,
    controller: 'LuckySixResultsController'
  };
});
